<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderRight :headerText="headerText" :headerTextEmpahasis="headerTextEmpahasis" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :headerTextEmpahasis="headerTextEmpahasis" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class="bv-example-row mt-5">
        <Activation />
        <b-row class="mb-4">
            <b-col md="2" cols="2">
                Mark as read
            </b-col>
            <b-col md="10" cols="10">
                <p class="text-center font18">Notifications</p>
            </b-col>
        </b-row>
        <div v-for="(notify, index) in notifications" :key="index">
            <b-row class="">
                <b-col md="1" cols="1">
                    <b-form-checkbox @change="markNotification(notify)" class="mt-2"></b-form-checkbox>
                </b-col>
                <b-col md="11" cols="11">
                    <b-alert show variant="secondary">
                        <a :href="notify.url">{{notify.message}}</a></b-alert>
                </b-col>
            </b-row>
        </div>

    </b-container>
    <Footer />

</div>
</template>

<script>
import axios from 'axios';
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderRight from "@/components/BlackHeaderRight.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";
import {
    getBaseUrl
} from "../../utils/common";
const base_url = getBaseUrl();
export default {
    name: "faq",
    data: function () {
        return {
            headerText: "Notifications",
            headerTextEmpahasis: "!",
            subText: "See all notifications",
            fadedText: "Notifications",
            notifications:[]
        }
    },
    components: {
        Header,
        BlackHeaderRight,
        BlackHeaderMobile,
        BodyLinks,
        Footer,
        Activation
    },
    mounted() {
       this.getNotifications();
    },
    methods: {
        async markNotification(notification) {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/activities?notification_id=${notification.notification_id}`,
                    method: "POST",
                })
                this.notifications = resp.data.data
            } catch (error) {
                this.$root.$refs.A.makeToast('warning', error.response.data.message)
            }
        },
        async getNotifications() {
            const resp = await this.$store.dispatch("getNotifications")
            this.notifications = resp.data.data
           
        },
    }
}
</script>

<style lang="scss" scoped>
a{
    color:#000
}
@media screen and (min-device-width: 340px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
    .card-body {
        background: #000;
        color: #fff
    }
}
</style>
